"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabbedComponentContainer = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const layout_1 = require("../layout");
const theme_1 = __importDefault(require("../../styles/theme"));
const TabbedComponentContainer = ({ tabLinks, 'data-testid': dataTestId, children, overflowY = 'auto', tabsPaddingBottom = '1.5rem', containerMarginX = 4, }) => {
    const [showShadow, setShowShadow] = (0, react_1.useState)(false);
    const handleScroll = (event) => {
        const notScrolled = event.currentTarget.scrollTop === 0;
        if (!notScrolled && !showShadow) {
            setShowShadow(true);
        }
        else if (notScrolled && showShadow) {
            setShowShadow(false);
        }
        else {
            return;
        }
    };
    return ((0, jsx_runtime_1.jsxs)(layout_1.Column, Object.assign({ flexGrow: 1, minHeight: "1px", "data-testid": dataTestId }, { children: [(0, jsx_runtime_1.jsx)(layout_1.Row, Object.assign({ style: {
                    transition: 'box-shadow 100ms ease-out',
                    backgroundColor: theme_1.default.colors.white,
                    paddingBottom: tabsPaddingBottom,
                }, flexShrink: 0, pb: 4, boxShadow: showShadow ? ' 0px 5px 5px -5px rgba(0,0,0,0.3);' : undefined, zIndex: 1, width: '100%' }, { children: tabLinks.map((tab) => tab.link()) })), (0, jsx_runtime_1.jsx)(layout_1.Column, Object.assign({ position: "relative", overflowY: overflowY, overflowX: "hidden", "data-testid": "tabbed-component-container", onScroll: handleScroll, mx: containerMarginX }, { children: children }))] })));
};
exports.TabbedComponentContainer = TabbedComponentContainer;
//# sourceMappingURL=tabbed_component_container.js.map